/**
 * @author Kvadrat and Skytta
 * This file is a copy form
 * https://github.com/inter-ikea/cbf-re-ipex-kvadrat
 *
 * The sortNumbers function was later added by the SKYTTA team
 */

/**
 * @param num The number to round
 * @param decimalPlaces The number of decimal places to preserve
 */
function round(num: number, decimalPlaces: number): number {
  const decimal = 10 ** decimalPlaces;
  return Math.round(num * decimal) / decimal;
}

export enum SortOrderEnum {
  Ascending,
  Descending
}

function sortNumbers(a: number, b: number, sortOrder: SortOrderEnum = SortOrderEnum.Ascending): number {
  return sortOrder === SortOrderEnum.Ascending ? a - b : b - a;
}

function sumArray(arr: number[]) {
  return arr.reduce((sum, num) => {
    return sum + num;
  }, 0);
}

export { round, sortNumbers, sumArray };
